import AnnouncementIcon from '../../../images/announcement-2.svg?component';
import ROUTE_NAMES from '../routeNames';
import SECTION_NAMES from '../sectionNames';
import { usePermissionsStore } from '@/vue/stores/permissions';

const meta = {
    title: SECTION_NAMES.ANNOUNCEMENT,
    icon: AnnouncementIcon,
    permissions: (): string[] => [usePermissionsStore().allPermissions.adminAnnouncements],
};

const AdminAnnouncementView = () => import('../../views/admin/AdminAnnouncement/AdminAnnouncementView.vue');

export default [
    {
        path: '',
        name: ROUTE_NAMES.ADMIN_ANNOUNCEMENT_LIST,
        component: () => import('../../views/admin/AdminAnnouncement/AdminAnnouncementList.vue'),
        meta,
    },
    {
        path: 'new',
        name: ROUTE_NAMES.ADMIN_ANNOUNCEMENT_NEW,
        component: AdminAnnouncementView,
        meta,
    },
    {
        path: 'edit/:id',
        name: ROUTE_NAMES.ADMIN_ANNOUNCEMENT_VIEW,
        component: AdminAnnouncementView,
        meta,
    },
];
